var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVideoPlay = function SvgVideoPlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#video-play_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#video-play_svg__b)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 23.714,
    cy: 24,
    r: 23.571,
    fill: "#fff",
    fillOpacity: 0.3
  })), /*#__PURE__*/React.createElement("path", {
    d: "M34.91 24.333 16.643 34.88V13.785L34.91 24.333Z",
    fill: "#fff",
    fillOpacity: 0.8
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "video-play_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.143 .428)",
    d: "M0 0h47.143v47.143H0z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "video-play_svg__b",
    x: -3,
    y: -2.714,
    width: 53.428,
    height: 53.428,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "BackgroundImageFix",
    stdDeviation: 1.571
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1697_23163"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_backgroundBlur_1697_23163",
    result: "shape"
  })))));
};
export default SvgVideoPlay;